export default "__VITE_ASSET__DJDOVMKH__"